import {PoliticaDescarteVinculacion} from './politica-descarte-vinculacion';
import {PoliticaAlertaVinculacion} from './politica-alerta-vinculacion';
import {Politica} from './politica';
import {PoliticaVinculacion} from './politica-vinculacion';
import { SelectItem } from 'primeng/api';
import { PoliticaPlanteamientoPolitica } from './politica-planteamiento-politica';
import {ListaItem} from './lista-item';
import {PoliticaPerfil} from './politica-perfil';
import {PoliticaOficina} from './politica-oficina';
import {PoliticaDescarteOficina} from './politica-descarte-oficina';
import {PoliticaModalidad} from './politica-modalidad';
import {PoliticaProducto} from './politica-producto';
import {ProductoPoliticaAlerta} from './producto-politica-alerta';
import {PoliticasPerfilesRiesgo} from './politicas-perfiles-riesgo';
import {PoliticaTipoProducto} from './politica-tipo-producto';


export class CentralizadaPoliticas {

  politica: Politica;
  descartes: boolean;
  vinculacionesNombres: string;
  idsVinculaciones: number[] = [];
  listaVinculaciones: ListaItem[] = [];
  listaCategoriasPoliticas: ListaItem[] = [];
  vinculacion: PoliticaVinculacion[] = [];
  descartesVinculaciones: PoliticaDescarteVinculacion [] = [];
  alerta: boolean;
  alertaVinculacion: PoliticaAlertaVinculacion[] = [];
  politicasPlanteamientosPoliticas: PoliticaPlanteamientoPolitica[] = [];
  perfiles: PoliticaPerfil[] = [];
  oficinas: PoliticaOficina[] = [];
  descarteOficinas: PoliticaDescarteOficina[] = [];
  modalidades: PoliticaModalidad[] = [];
  productos: ProductoPoliticaAlerta[] = [];

  listPoliticasPerfilesRiesgos: PoliticasPerfilesRiesgo[] = [];
  politicasPerfilRiesgo: PoliticasPerfilesRiesgo;
  politicaPlanteamiento: PoliticaPlanteamientoPolitica;
  lisPoliticaPlanteaminetoEliminadas: PoliticaPlanteamientoPolitica[] = [];
  tipoProducto: PoliticaTipoProducto[] = [];

  constructor() {
    this.descartes = false;
    this.alerta = false;
    this.politica = {} as Politica;
    this.idsVinculaciones = [];
    this.listaVinculaciones = [];
    this.listaCategoriasPoliticas = [];
    this.vinculacion = [];
    this.descartesVinculaciones = [];
    this.alertaVinculacion = [];
    this.perfiles = [];
    this.oficinas = [];
    this.descarteOficinas = [];
    this.modalidades = [];
    this.productos = [];
    this.listPoliticasPerfilesRiesgos = [];
    this.politicasPerfilRiesgo = {} as PoliticasPerfilesRiesgo;
    this.politicaPlanteamiento = {} as PoliticaPlanteamientoPolitica;
    this.lisPoliticaPlanteaminetoEliminadas = [];
    this.tipoProducto = [];
  }
}
